import React, { ReactNode } from 'react';
import { banner, formlogo } from '../../assets/images/index';

interface NonAuthLayoutProps {
  children: ReactNode;
  social_login_text?: string;
}

const NonAuthLayout: React.FC<NonAuthLayoutProps> = ({ children }) => {
  return (
    <div className="auth_layout">
      <div className="auth_banner">
        <img src={banner} className="max-height-image" alt="Full-size" />
      </div>
      <div className="auth_content">
        <div className="auth_logo">
          <img src={formlogo} alt="Logo" />
        </div>
        <div className="form">{children}</div>
        <div className="auth_footer">
          {/* {social_login_text == 'reset-password' ? (
            <></>
          ) : (
            <SocialLogin page={social_login_text} />
          )} */}
        </div>
      </div>
    </div>
  );
};

export default NonAuthLayout;
